import React, { useState } from "react";
import {  toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppBreadcrumbs from "../components/ui/AppBreadcrumbs";
import Main from "../pages/Main";
const BBPSBill = () => {
  const [form, setForm] = useState({
    merchantCode: "",
    merchantName: "",
    mobileNumber: "",
    aadhaarMobile: "",
    panNumber: "",
    aadhaarNumber: "",
    email: "",
    dob: "",
    accountNumber: "",
    ifscCode: "",
  });
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    for (let key in form) {
      if (!form[key].trim()) {
        toast.error("Please fill all required fields.", {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }
    }
    toast.success("Form submitted successfully!", {
      position: "top-center",
      autoClose: 2000,
    });
  };
  const handleReset = () => {
    setForm({
      merchantCode: "",
      merchantName: "",
      mobileNumber: "",
      aadhaarMobile: "",
      panNumber: "",
      aadhaarNumber: "",
      email: "",
      dob: "",
      accountNumber: "",
      ifscCode: "",
    });
    toast.info("Form reset successfully!", {
      position: "top-center",
      autoClose: 2000,
    });
  };
  return (
    <Main showRightPanel={false}>
      <div className="flex flex-col lg:flex-row flex-1 p-4 sm:p-6 lg:pl-8">
        <div className="flex-1 flex flex-col">
          <AppBreadcrumbs
            items={[
              { label: "Dashboard", to: "/" },
              { label: "Marketplace" },
              { label: "Utility Payments" },
              { label: "Merchant Onboarding" },
            ]}
          />
          <div className="ds-card p-4 sm:p-6 w-full max-w-4xl mb-4 mt-3">
            <h2 className="text-[15px] sm:text-lg font-semibold text-[var(--text-dark)] mb-3">
              Your Details for Utility Payment – Merchant OnBoarding
            </h2>
            <p className="text-sm mb-4">
              <span className="font-bold text-[var(--error-color)]">Note :</span>{" "}
             <span className="font-bold text-[var(--success-color)]"> Confirm and provide required details as per your KYC documents like PAN Card and Aadhaar Card.</span>
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="ds-label">
                    Your Merchant Code <span className="text-[var(--error-color)]">*</span>
                  </label>
                  <input
                    name="merchantCode"
                    value={form.merchantCode}
                    onChange={handleChange}
                    placeholder="Enter Merchant Code"
                    className="ds-input"/>
                </div>
                <div>
                  <label className="ds-label">
                    Your Name (In Merchant ID) <span className="text-[var(--error-color)]">*</span>
                  </label>
                  <input
                    name="merchantName"
                    value={form.merchantName}
                    onChange={handleChange}
                    placeholder="Enter Name"
                    className="ds-input"/>
                </div>
                <div>
                  <label className="ds-label">
                    Mobile Number (In Merchant ID) <span className="text-[var(--error-color)]">*</span>
                  </label>
                  <input
                    name="mobileNumber"
                    value={form.mobileNumber}
                    onChange={handleChange}
                    placeholder="Enter Mobile Number"
                    className="ds-input"/>
                </div>
                <div>
                  <label className="ds-label">
                    Aadhaar Link Mobile Number <span className="text-[var(--error-color)]">*</span>
                  </label>
                  <input
                    name="aadhaarMobile"
                    value={form.aadhaarMobile}
                    onChange={handleChange}
                    placeholder="Enter Aadhaar Link Mobile Number"
                    className="ds-input"/>
                </div>
                <div>
                  <label className="ds-label">
                    Your PAN Card Number <span className="text-[var(--error-color)]">*</span>
                  </label>
                  <input
                    name="panNumber"
                    value={form.panNumber}
                    onChange={handleChange}
                    placeholder="Enter PAN Number"
                    className="ds-input"/>
                </div>
                <div>
                  <label className="ds-label">
                    Aadhaar Number <span className="text-[var(--error-color)]">*</span>
                  </label>
                  <input
                    name="aadhaarNumber"
                    value={form.aadhaarNumber}
                    onChange={handleChange}
                    placeholder="Enter Aadhaar Number"
                    className="ds-input"
                  />
                </div>
                <div>
                  <label className="ds-label">
                    Email Address <span className="text-[var(--error-color)]">*</span>
                  </label>
                  <input
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Enter Email"
                    className="ds-input"/>
                </div>
                <div>
                  <label className="ds-label">
                    Date of Birth <span className="text-[var(--error-color)]">*</span>
                  </label>
                  <input
                    type="date"
                    name="dob"
                    value={form.dob}
                    onChange={handleChange}
                    className="ds-input"/>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
              <a href="#" className="make-text-primary font-semibold mt-3 underline">
                SETTLEMENT ACCOUNT DETAILS
              </a>
              </div>
              <div>
                <button type="button" className="ds-btn ds-btn-ghost text-[var(--error-color)] border border-[var(--error-color)]">
                  Account Not Added?
                </button>
              </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="ds-label">
                    Account Number <span className="text-[var(--error-color)]">*</span>
                  </label>
                  <input
                    name="accountNumber"
                    value={form.accountNumber}
                    onChange={handleChange}
                    placeholder="Enter Account Number"
                    className="ds-input"/>
                </div>
                <div>
                  <label className="ds-label">
                    IFSC Code <span className="text-[var(--error-color)]">*</span>
                  </label>
                  <input
                    name="ifscCode"
                    value={form.ifscCode}
                    onChange={handleChange}
                    placeholder="Enter IFSC Code"
                    className="ds-input"/>
                </div>
              </div>
<div className="mt-4 border border-[var(--border-color)] rounded-md p-3 flex items-start gap-3">
  <input
    type="checkbox"
    className="mt-1"
    name="consent"/>
  <p className="text-sm leading-5 whitespace-normal text-[var(--text-muted)]">
    I hereby give my consent and submit voluntarily at my own discretion, My Aadhaar Number or VID
    for the purpose of establishing my identity on the portal. The Aadhaar submitted herewith
    shall not be used for any purpose other than mentioned, or as per the requirements of the law.
  </p>
</div>
<button
  type="button"
  className="ds-btn ds-btn-primary mt-4">
  Verify & Proceed
</button>
            </form>
          </div>
        </div>
      </div>
    </Main>
  );
};
export default BBPSBill;
